import React from 'react'
import ActuatorOption from './ActuatorOption'
import DaySelector from 'src/Libs/inputs/react-hook-form/DaySelector/DaySelector'

/**
 * Selection of days for repeating an actuator command. Used in actuators that support a repeat option, e.g. timer.
 */
const ActuatorRepeatOption: React.FC = () => {
  return (
    <ActuatorOption title={'smart-home.common.repeat.title'}>
      <DaySelector name="week" disabledDays={[]} sx={{ flexWrap: 'wrap' }} />
    </ActuatorOption>
  )
}

export default ActuatorRepeatOption
